import Vue from "vue";
import VueRouter from "vue-router";
import Bankruptcy from "../views/Bankruptcy";
import Login from "../views/auth/Login";
import Register from "../views/auth/Register";
import PasswordReset from "../views/auth/PasswordReset";
import PasswordResetConfirm from "../views/auth/PasswordResetConfirm";
import Profile from "../views/auth/Profile";
import GeneratedForms from "../views/GeneratedForms";
import ConfirmRegistration from "../views/auth/ConfirmRegistration";

import DocsExamples from "../views/DocsExamples";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Bankruptcy",
    component: Bankruptcy
  },
  {
    path: "/profile/",
    name: "Profile",
    component: Profile
  },
  {
    path: "/generatedforms/",
    name: "GeneratedForms",
    component: GeneratedForms
  },
  {
    path: "/auth/login/",
    name: "Login",
    component: Login
  },
  {
    path: "/auth/register/",
    name: "Register",
    component: Register
  },
  {
    path: "/auth/confirm-registration/",
    name: "ConfirmRegistration",
    component: ConfirmRegistration
  },
  {
    path: "/auth/password-reset/",
    name: "PasswordReset",
    component: PasswordReset
  },
  {
    path: "/auth/password-reset/confirm/",
    name: "PasswordResetConfirm",
    component: PasswordResetConfirm
  },
  {
    path: "/docsexamples/",
    name: "Docsexamples",
    component: DocsExamples
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
